export default "__VITE_ASSET__CrexTWi1__ 480w, __VITE_ASSET__CZYaA7Hp__ 768w, __VITE_ASSET__CRsbVTQB__ 1024w, __VITE_ASSET__DcenfUYv__ 1184w";